import TaskerTestimonialImg1 from "../assets/login/setnewpassword.webp";
import TaskerTestimonialImg2 from "../assets/landing/tasker-testimonial-2.png";
import TaskerTestimonialImg3 from "../assets/landing/tasker-testimonial-3.png";
import { offerStatus, orderStatus } from "../constants/commonConstants";

export const clientsTestimonials = [
  {
    name: "Sarah M.",
    role: "Homeowner",
    image: "https://dashboard.codeparrot.ai/api/assets/Z4uwwSAPZCF-suOb",
    quote:
      "The professionals are top-notch! I've used Tasker for plumbing and electrical work, and both experiences were fantastic. Reliable and trustworthy.",
    title: "Top-Quality Professionals You Can Rely On",
    socials: {
      twitter: "https://x.com",
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
    },
  },
  {
    name: "John D.",
    role: "Business Owner",
    image:
      "https://plus.unsplash.com/premium_photo-1690407617686-d449aa2aad3c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    quote:
      "Tasker has been a game-changer for my business! Their prompt service and skilled workers make everything easier.",
    title: "Dependable Services for Businesses",
    socials: {
      twitter: "https://x.com",
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
    },
  },
  {
    name: "Emily R.",
    role: "Freelancer",
    image:
      "https://images.unsplash.com/photo-1541577141970-eebc83ebe30e?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    quote:
      "Highly recommended! Tasker connects you with skilled professionals who deliver excellent results every time.",
    title: "Professionals You Can Trust",
    socials: {
      twitter: "https://x.com",
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
    },
  },
];

export const taskersTestimonials = [
  {
    name: "Sarah Bennett",
    role: "Handyman Specialist (Plumbing & Repairs)",
    image: TaskerTestimonialImg1,
    quote:
      "This platform has been a game-changer for me. The secure payment system ensures I get paid on time, and the real-time notifications help me stay on top of new opportunities. Highly recommend it to all professionals!",
    title: "Secure Payments, Zero Hassle",
    socials: {
      twitter: "https://x.com",
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
    },
  },
  {
    name: "Emma Taylor",
    role: "Furniture Assembly Expert",
    image: TaskerTestimonialImg2,
    quote:
      "I love how user-friendly the dashboard is! It makes managing my tasks and client communication so seamless. Plus, having access to a larger client base has significantly boosted my bookings.",
    title: "Connecting with More Clients, Effortlessly",
    socials: {
      twitter: "https://x.com",
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
    },
  },
  {
    name: "Olivia Carter",
    role: "Electrical Maintenance Specialist",
    image: TaskerTestimonialImg3,
    quote:
      "The flexible work hours feature is my favorite. I can choose tasks that fit my schedule, and the platform ensures secure and hassle-free payments. It’s the best way to connect with clients.",
    title: "Flexible Work That Fits My Schedule",
    socials: {
      twitter: "https://x.com",
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
    },
  },
];

export const categories = [
  { _id: "1", name: "General Handyman Services" },
  { _id: "2", name: "Home Service" },
  { _id: "3", name: "Plumbing Services" },
  { _id: "4", name: "Electrical Services" },
  { _id: "5", name: "Painting and Decorating" },
  { _id: "6", name: "Cleaning Services" },
  { _id: "7", name: "Moving Assistance" },
  { _id: "8", name: "Outdoor Work" },
  { _id: "9", name: "Home Renovation Support" },
  { _id: "10", name: "Personal Assistance" },
  { _id: "11", name: "Delivery Services" },
  { _id: "12", name: "Office and Business Services" },
  { _id: "13", name: "Technology Support" },
  { _id: "14", name: "Creative Services" },
  { _id: "15", name: "Events and Parties" },
  { _id: "16", name: "Education and Tutoring" },
  { _id: "17", name: "Odd Jobs" },
  { _id: "18", name: "Lifestyle Services" },
  { _id: "19", name: "Specialized Services" },
  { _id: "20", name: "Tailor Services" },
  { _id: "21", name: "Photography Services" },
  { _id: "22", name: "Gardening Services" },
];

export const skills = [
  { _id: "1", category_id: "1", name: "Dusting" },
  { _id: "2", category_id: "1", name: "Mopping" },
  { _id: "3", category_id: "2", name: "Lawn Mowing" },
  { _id: "4", category_id: "2", name: "Hedge Trimming" },
  { _id: "5", category_id: "3", name: "Pipe Fitting" },
  { _id: "6", category_id: "3", name: "Leak Fixing" },
  { _id: "7", category_id: "4", name: "Wiring" },
  { _id: "8", category_id: "4", name: "Appliance Repair" },
  { _id: "9", category_id: "5", name: "Wall Painting" },
  { _id: "10", category_id: "5", name: "Spray Painting" },
  { _id: "11", category_id: "6", name: "Furniture Assembly" },
  { _id: "12", category_id: "6", name: "Wood Polishing" },
];

export const cities = [
  { _id: "1", name: "Accra" },
  { _id: "2", name: "Kumasi" },
  { _id: "3", name: "Tamale" },
  { _id: "4", name: "Takoradi" },
  { _id: "5", name: "Tema" },
  { _id: "6", name: "Cape Coast" },
  { _id: "7", name: "Koforidua" },
  { _id: "8", name: "Ho" },
  { _id: "9", name: "Bolgatanga" },
  { _id: "10", name: "Sunyani" },
  { _id: "11", name: "Wa" },
  { _id: "12", name: "Nkawkaw" },
  { _id: "13", name: "Obuasi" },
  { _id: "14", name: "Dunkwa-on-Offin" },
  { _id: "15", name: "Techiman" },
  { _id: "16", name: "Tarkwa" },
  { _id: "17", name: "Konongo" },
  { _id: "18", name: "Winneba" },
  { _id: "19", name: "Mampong" },
  { _id: "20", name: "Bibiani" },
];

export const subcities = [
  { _id: "1-1", name: "Madina", cityId: "1" },
  { _id: "1-2", name: "Osu", cityId: "1" },
  { _id: "1-3", name: "Dansoman", cityId: "1" },
  { _id: "1-4", name: "Spintex", cityId: "1" },

  { _id: "2-1", name: "Asokwa", cityId: "2" },
  { _id: "2-2", name: "Suame", cityId: "2" },
  { _id: "2-3", name: "Bantama", cityId: "2" },

  { _id: "3-1", name: "Lamashegu", cityId: "3" },
  { _id: "3-2", name: "Choggu", cityId: "3" },
  { _id: "3-3", name: "Gumbihini", cityId: "3" },
];

export const searchableDropdownOptionsForTesting = [
  {
    id: 1,
    value: "category1",
    label: "Category 1",
    firstName: "John",
    lastName: "Doe",
  },
  {
    id: 2,
    value: "category2",
    label: "Category 2",
    firstName: "Jane",
    lastName: "Doe",
  },
  {
    id: 3,
    value: "category3",
    label: "Category 3",
    firstName: "Alice",
    lastName: "Doe",
  },
  {
    id: 4,
    value: "category4",
    label: "Category 4",
    firstName: "Bob",
    lastName: "Doe",
  },
  {
    id: 5,
    value: "category5",
    label: "Category 5",
    firstName: "Eve",
    lastName: "Doe",
  },
  {
    id: 6,
    value: "category6",
    label: "Category 6",
    firstName: "Charlie",
    lastName: "Doe",
  },
  {
    id: 7,
    value: "category7",
    label: "Category 7",
    firstName: "David",
    lastName: "Doe",
  },
  {
    id: 8,
    value: "category8",
    label: "Category 8",
    firstName: "Eva",
    lastName: "Doe",
  },
  {
    id: 9,
    value: "category9",
    label: "Category 9",
    firstName: "Frank",
    lastName: "Doe",
  },
  {
    id: 10,
    value: "category10",
    label: "Category 10",
    firstName: "Grace",
    lastName: "Doe",
  },
];

export const servicesPros = [
  {
    id: 1,
    firstName: "John",
    lastName: "Doe",
    professionalDetails: [
      {
        categoryName: "General Handyman Services",
        skills: [
          {
            name: "Furniture Assembly",
            description: "I can assemble all types of furniture",
          },
          {
            name: "Hanging Pictures and Shelves",
            description: "I can hang pictures and shelves",
          },
          {
            name: "Door Repair",
            description: "I can repair doors",
          },
          {
            name: "Lock Replacement",
            description: "I can replace locks",
          },
          {
            name: "Basic Carpentry Work",
            description: "I can do basic carpentry work",
          },
          {
            name: "Window Repair",
            description: "I can repair windows",
          },
          {
            name: "Curtain and Blinds Installation",
            description: "I can install curtains and blinds",
          },
        ],
      },
      {
        categoryName: "Home Services",
        skills: [
          {
            name: "Moving Help",
            description: "I can help you move your stuff",
          },
          {
            name: "Pest Control Assistance",
            description: "I can help you with pest control",
          },
          {
            name: "Home Organization (closet, kitchen, etc.)",
            description: "I can help you organize your home",
          },
        ],
      },
    ],
    location: "Accra",
    rating: 4.5,
    reviews: 100,
    profilePicture:
      "https://dashboard.codeparrot.ai/api/image/Z5eCQtgGlUAkMdK1/ellipse.png",
  },
  {
    id: 2,
    firstName: "Jane",
    lastName: "Doe",
    professionalDetails: [
      {
        categoryName: "General Handyman Services",
        skills: [
          {
            name: "Furniture Assembly",
            description: "I can assemble all types of furniture",
          },
          {
            name: "Hanging Pictures and Shelves",
            description: "I can hang pictures and shelves",
          },
          {
            name: "Door Repair",
            description: "I can repair doors",
          },
          {
            name: "Lock Replacement",
            description: "I can replace locks",
          },
          {
            name: "Basic Carpentry Work",
            description: "I can do basic carpentry work",
          },
          {
            name: "Window Repair",
            description: "I can repair windows",
          },
          {
            name: "Curtain and Blinds Installation",
            description: "I can install curtains and blinds",
          },
        ],
      },
      {
        categoryName: "Home Services",
        skills: [
          {
            name: "Moving Help",
            description: "I can help you move your stuff",
          },
          {
            name: "Pest Control Assistance",
            description: "I can help you with pest control",
          },
          {
            name: "Home Organization (closet, kitchen, etc.)",
            description: "I can help you organize your home",
          },
        ],
      },
    ],
    location: "Kumasi",
    rating: 4.0,
    reviews: 80,
    profilePicture:
      "https://plus.unsplash.com/premium_photo-1664298589198-b15ff5382648?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8cGx1bWJlcnxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 3,
    firstName: "Alice",
    lastName: "Doe",
    professionalDetails: [
      {
        categoryName: "General Handyman Services",
        skills: [
          {
            name: "Furniture Assembly",
            description: "I can assemble all types of furniture",
          },
          {
            name: "Hanging Pictures and Shelves",
            description: "I can hang pictures and shelves",
          },
          {
            name: "Door Repair",
            description: "I can repair doors",
          },
          {
            name: "Lock Replacement",
            description: "I can replace locks",
          },
          {
            name: "Basic Carpentry Work",
            description: "I can do basic carpentry work",
          },
          {
            name: "Window Repair",
            description: "I can repair windows",
          },
          {
            name: "Curtain and Blinds Installation",
            description: "I can install curtains and blinds",
          },
        ],
      },
      {
        categoryName: "Home Services",
        skills: [
          {
            name: "Moving Help",
            description: "I can help you move your stuff",
          },
          {
            name: "Pest Control Assistance",
            description: "I can help you with pest control",
          },
          {
            name: "Home Organization (closet, kitchen, etc.)",
            description: "I can help you organize your home",
          },
        ],
      },
    ],
    location: "Tamale",
    rating: 4.2,
    reviews: 90,
    profilePicture:
      "https://plus.unsplash.com/premium_photo-1679765934200-d1cb3153c631?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8R2FyZGVuaW5nfGVufDB8fDB8fHww",
  },
  {
    id: 4,
    firstName: "Bob",
    lastName: "Doe",
    professionalDetails: [
      {
        categoryName: "General Handyman Services",
        skills: [
          {
            name: "Furniture Assembly",
            description: "I can assemble all types of furniture",
          },
          {
            name: "Hanging Pictures and Shelves",
            description: "I can hang pictures and shelves",
          },
          {
            name: "Door Repair",
            description: "I can repair doors",
          },
          {
            name: "Lock Replacement",
            description: "I can replace locks",
          },
          {
            name: "Basic Carpentry Work",
            description: "I can do basic carpentry work",
          },
          {
            name: "Window Repair",
            description: "I can repair windows",
          },
          {
            name: "Curtain and Blinds Installation",
            description: "I can install curtains and blinds",
          },
        ],
      },
      {
        categoryName: "Home Services",
        skills: [
          {
            name: "Moving Help",
            description: "I can help you move your stuff",
          },
          {
            name: "Pest Control Assistance",
            description: "I can help you with pest control",
          },
          {
            name: "Home Organization (closet, kitchen, etc.)",
            description: "I can help you organize your home",
          },
        ],
      },
    ],
    location: "Takoradi",
    rating: 4,
    reviews: 95,
    profilePicture:
      "https://plus.unsplash.com/premium_photo-1661929137248-2544fd28de13?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8RWxlY3RyY2llbnxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 5,
    firstName: "Eve",
    lastName: "Doe",
    professionalDetails: [
      {
        categoryName: "General Handyman Services",
        skills: [
          {
            name: "Furniture Assembly",
            description: "I can assemble all types of furniture",
          },
          {
            name: "Hanging Pictures and Shelves",
            description: "I can hang pictures and shelves",
          },
          {
            name: "Door Repair",
            description: "I can repair doors",
          },
          {
            name: "Lock Replacement",
            description: "I can replace locks",
          },
          {
            name: "Basic Carpentry Work",
            description: "I can do basic carpentry work",
          },
          {
            name: "Window Repair",
            description: "I can repair windows",
          },
          {
            name: "Curtain and Blinds Installation",
            description: "I can install curtains and blinds",
          },
        ],
      },
      {
        categoryName: "Home Services",
        skills: [
          {
            name: "Moving Help",
            description: "I can help you move your stuff",
          },
          {
            name: "Pest Control Assistance",
            description: "I can help you with pest control",
          },
          {
            name: "Home Organization (closet, kitchen, etc.)",
            description: "I can help you organize your home",
          },
        ],
      },
    ],
    location: "Tema",
    rating: 4.3,
    reviews: 85,
    profilePicture:
      "https://plus.unsplash.com/premium_photo-1679500354245-ce715b79a606?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Njl8fHJvb20lMjBjbGVhbmVyfGVufDB8fDB8fHww",
  },
  {
    id: 6,
    firstName: "Charlie",
    lastName: "Doe",
    professionalDetails: [
      {
        categoryName: "General Handyman Services",
        skills: [
          {
            name: "Furniture Assembly",
            description: "I can assemble all types of furniture",
          },
          {
            name: "Hanging Pictures and Shelves",
            description: "I can hang pictures and shelves",
          },
          {
            name: "Door Repair",
            description: "I can repair doors",
          },
          {
            name: "Lock Replacement",
            description: "I can replace locks",
          },
          {
            name: "Basic Carpentry Work",
            description: "I can do basic carpentry work",
          },
          {
            name: "Window Repair",
            description: "I can repair windows",
          },
          {
            name: "Curtain and Blinds Installation",
            description: "I can install curtains and blinds",
          },
        ],
      },
      {
        categoryName: "Home Services",
        skills: [
          {
            name: "Moving Help",
            description: "I can help you move your stuff",
          },
          {
            name: "Pest Control Assistance",
            description: "I can help you with pest control",
          },
          {
            name: "Home Organization (closet, kitchen, etc.)",
            description: "I can help you organize your home",
          },
        ],
      },
    ],
    location: "Cape Coast",
    rating: 4.4,
    reviews: 75,
    profilePicture:
      "https://plus.unsplash.com/premium_photo-1677151140434-302945fcc26a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fENhcnBlbnRlcnxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 7,
    firstName: "David",
    lastName: "Doe",
    professionalDetails: [
      {
        categoryName: "General Handyman Services",
        skills: [
          {
            name: "Furniture Assembly",
            description: "I can assemble all types of furniture",
          },
          {
            name: "Hanging Pictures and Shelves",
            description: "I can hang pictures and shelves",
          },
          {
            name: "Door Repair",
            description: "I can repair doors",
          },
          {
            name: "Lock Replacement",
            description: "I can replace locks",
          },
          {
            name: "Basic Carpentry Work",
            description: "I can do basic carpentry work",
          },
          {
            name: "Window Repair",
            description: "I can repair windows",
          },
          {
            name: "Curtain and Blinds Installation",
            description: "I can install curtains and blinds",
          },
        ],
      },
      {
        categoryName: "Home Services",
        skills: [
          {
            name: "Moving Help",
            description: "I can help you move your stuff",
          },
          {
            name: "Pest Control Assistance",
            description: "I can help you with pest control",
          },
          {
            name: "Home Organization (closet, kitchen, etc.)",
            description: "I can help you organize your home",
          },
        ],
      },
    ],
    location: "Koforidua",
    rating: 4.6,
    reviews: 105,
    profilePicture:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
  },
];

export const clientReviews = [
  {
    id: 1,
    name: "Sarah M.",
    role: "Homeowner",
    image:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    quote:
      "The professionals are top-notch! I've used Tasker for plumbing and electrical work, and both experiences were fantastic. Reliable and trustworthy.",
    rating: 5,
    date: "2024-05-31",
    price: "$150.00",
  },
  {
    id: 2,
    name: "John D.",
    role: "Business Owner",
    image:
      "https://plus.unsplash.com/premium_photo-1690407617686-d449aa2aad3c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    quote:
      "Tasker has been a game-changer for my business! Their prompt service and skilled workers make everything easier.",
    rating: 4,
    date: "2024-06-01",
    price: "$200.00",
  },
  {
    id: 3,
    name: "Emily R.",
    role: "Freelancer",
    image:
      "https://images.unsplash.com/photo-1541577141970-eebc83ebe30e?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    quote:
      "Highly recommended! Tasker connects you with skilled professionals who deliver excellent results every time.",
    rating: 4.5,
    date: "2024-06-02",
    price: "$250.00",
  },
  {
    id: 4,
    name: "Mark S.",
    role: "Homeowner",
    image:
      "https://plus.unsplash.com/premium_photo-1679765934200-d1cb3153c631?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8R2FyZGVuaW5nfGVufDB8fDB8fHww",
    quote:
      "Tasker is the best! I've used them for multiple projects and have never been disappointed. Great service!",
    rating: 4.2,
    date: "2024-06-03",
    price: "$300.00",
  },
  {
    id: 5,
    name: "Alice W.",
    role: "Business Owner",
    image:
      "https://plus.unsplash.com/premium_photo-1664298589198-b15ff5382648?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8cGx1bWJlcnxlbnwwfHwwfHx8MA%3D%3D",
    quote:
      "I've been using Tasker for years and they never disappoint. Great service and great people!",
    rating: 4.3,
    date: "2024-06-04",
    price: "$350.00",
  },
  {
    id: 6,
    name: "David M.",
    role: "Freelancer",
    image:
      "https://plus.unsplash.com/premium_photo-1661664680618-7f10c69d1075?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    quote:
      "Tasker is the best! I've used them for multiple projects and have never been disappointed. Great service!",
    rating: 4.4,
    date: "2024-06-05",
    price: "$400.00",
  },
  {
    id: 7,
    name: "Eve S.",
    role: "Homeowner",
    image:
      "https://plus.unsplash.com/premium_photo-1679500354245-ce715b79a606?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Njl8fHJvb20lMjBjbGVhbmVyfGVufDB8fDB8fHww",
    quote:
      "Tasker is the best! I've used them for multiple projects and have never been disappointed. Great service!",
    rating: 4.6,
    date: "2024-06-06",
    price: "$450.00",
  },
  {
    id: 8,
    name: "Frank D.",
    role: "Business Owner",
    image:
      "https://plus.unsplash.com/premium_photo-1661929137248-2544fd28de13?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8RWxlY3RyY2llbnxlbnwwfHwwfHx8MA%3D%3D",
    quote:
      "Tasker is the best! I've used them for multiple projects and have never been disappointed. Great service!",
    rating: 4.7,
    date: "2024-06-07",
    price: "$500.00",
  },
  {
    id: 9,
    name: "Grace M.",
    role: "Freelancer",
    image:
      "https://plus.unsplash.com/premium_photo-1677151140434-302945fcc26a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fENhcnBlbnRlcnxlbnwwfHwwfHx8MA%3D%3D",
    quote:
      "Tasker is the best! I've used them for multiple projects and have never been disappointed. Great service!",
    rating: 4.8,
    date: "2024-06-08",
    price: "$550.00",
  },
  {
    id: 10,
    name: "Hannah D.",
    role: "Homeowner",
    image:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    quote:
      "Tasker is the best! I've used them for multiple projects and have never been disappointed. Great service!",
    rating: 4.9,
    date: "2024-06-09",
    price: "$600.00",
  },
];

export const orderHistory = [
  {
    _id: "1",
    orderId: "1001",
    orderDate: "2024-12-20T09:50:13.862+00:00",
    orderStatus: orderStatus.IN_PROGRESS,
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "John",
      lastName: "Doe",
    },
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
    ],
    amount: 200,
  },
  {
    _id: "2",
    orderId: "1002",
    orderDate: "2024-12-21T09:50:13.862+00:00",
    orderStatus: orderStatus.IN_REVISION,
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
      {
        status: orderStatus.DELIVERED,
        date: "2024-12-21T09:50:13.862+00:00",
      },
      {
        status: orderStatus.IN_REVISION,
        date: "2024-12-21T09:50:13.862+00:00",
      },
    ],
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "Jane",
      lastName: "Doe",
    },
    amount: 200,
  },
  {
    _id: "3",
    orderId: "1003",
    orderDate: "2024-12-22T09:50:13.862+00:00",
    orderStatus: orderStatus.COMPLETED,
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
      {
        status: orderStatus.DELIVERED,
        date: "2024-12-21T09:50:13.862+00:00",
      },
      {
        status: orderStatus.COMPLETED,
        date: "2024-12-22T09:50:13.862+00:00",
      },
    ],
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "Alice",
      lastName: "Doe",
    },
    amount: 200,
  },
  {
    _id: "4",
    orderId: "1004",
    orderDate: "2024-12-23T09:50:13.862+00:00",
    orderStatus: orderStatus.COMPLAINT_RAISED,
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
      {
        status: orderStatus.DELIVERED,
        date: "2024-12-21T09:50:13.862+00:00",
      },
      {
        status: orderStatus.COMPLETED,
        date: "2024-12-22T09:50:13.862+00:00",
      },
      {
        status: orderStatus.COMPLAINT_RAISED,
        date: "2024-12-23T09:50:13.862+00:00",
      },
    ],
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "Bob",
      lastName: "Doe",
    },
    amount: 200,
  },
  {
    _id: "5",
    orderId: "1005",
    orderDate: "2024-12-24T09:50:13.862+00:00",
    orderStatus: orderStatus.RESOLVED,
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
      {
        status: orderStatus.DELIVERED,
        date: "2024-12-21T09:50:13.862+00:00",
      },
      {
        status: orderStatus.COMPLETED,
        date: "2024-12-22T09:50:13.862+00:00",
      },
      {
        status: orderStatus.COMPLAINT_RAISED,
        date: "2024-12-23T09:50:13.862+00:00",
      },
      {
        status: orderStatus.RESOLVED,
        date: "2024-12-24T09:50:13.862+00:00",
      },
    ],
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "Eve",
      lastName: "Doe",
    },
    amount: 200,
  },
  {
    _id: "6",
    orderId: "1006",
    orderDate: "2024-12-25T09:50:13.862+00:00",
    orderStatus: orderStatus.COMPLETED,
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
      {
        status: orderStatus.DELIVERED,
        date: "2024-12-21T09:50:13.862+00:00",
      },
      {
        status: orderStatus.IN_REVISION,
        date: "2024-12-22T09:50:13.862+00:00",
      },
      {
        status: orderStatus.DELIVERED,
        date: "2024-12-23T09:50:13.862+00:00",
      },
      {
        status: orderStatus.COMPLETED,
        date: "2024-12-25T09:50:13.862+00:00",
      },
    ],
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "Charlie",
      lastName: "Doe",
    },
    amount: 200,
  },
  {
    _id: "7",
    orderId: "1007",
    orderDate: "2024-12-26T09:50:13.862+00:00",
    orderStatus: orderStatus.DELIVERED,
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
      {
        status: orderStatus.DELIVERED,
        date: "2024-12-21T09:50:13.862+00:00",
      },
    ],
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "David",
      lastName: "Doe",
    },
    amount: 200,
  },
  {
    _id: "8",
    orderId: "1008",
    orderDate: "2024-12-27T09:50:13.862+00:00",
    orderStatus: orderStatus.IN_PROGRESS,
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
    ],
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "Eva",
      lastName: "Doe",
    },
    amount: 200,
  },
  {
    _id: "9",
    orderId: "1009",
    orderDate: "2024-12-28T09:50:13.862+00:00",
    orderStatus: orderStatus.COMPLAINT_RAISED,
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
      {
        status: orderStatus.DELIVERED,
        date: "2024-12-21T09:50:13.862+00:00",
      },
      {
        status: orderStatus.COMPLETED,
        date: "2024-12-22T09:50:13.862+00:00",
      },
      {
        status: orderStatus.COMPLAINT_RAISED,
        date: "2024-12-23T09:50:13.862+00:00",
      },
    ],
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "Frank",
      lastName: "Doe",
    },
    amount: 200,
  },
  {
    _id: "10",
    orderId: "1010",
    orderDate: "2024-12-29T09:50:13.862+00:00",
    orderStatus: orderStatus.COMPLETED,
    orderFlow: [
      {
        status: orderStatus.IN_PROGRESS,
        date: "2024-12-20T09:50:13.862+00:00",
      },
      {
        status: orderStatus.DELIVERED,
        date: "2024-12-21T09:50:13.862+00:00",
      },
      {
        status: orderStatus.COMPLETED,
        date: "2024-12-22T09:50:13.862+00:00",
      },
    ],
    taskTitle: "Plumbing Repair and Electrical Checkup",
    tasker: {
      firstName: "Grace",
      lastName: "Doe",
    },
    amount: 200,
  },
];

export const taskers = [
  {
    userId: "T001",
    name: "Michael Smith",
    firstName: "Michael",
    lastName: "Smith",
    role: "TASKER",
    category: "Plumber",
    avatar:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    isOnline: true,
    isTyping: true,
    lastMessageTime: "5min ago",
    unreadCount: 2,
  },
  {
    userId: "T002",
    name: "John Doe",
    firstName: "John",
    lastName: "Doe",
    role: "TASKER",
    category: "Electrician",
    avatar:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    isOnline: true,
    isTyping: false,
    lastMessageTime: "2h ago",
    unreadCount: 0,
  },
  {
    userId: "T003",
    name: "Emma Watson",
    firstName: "Emma",
    lastName: "W.",
    role: "TASKER",
    category: "Interior Designer",
    avatar: "",
    isOnline: false,
    isTyping: false,
    lastMessageTime: "1d ago",
    unreadCount: 1,
  },
  {
    userId: "T004",
    name: "Michael R.",
    firstName: "Michael",
    lastName: "R.",
    role: "TASKER",
    category: "Carpenter",
    avatar:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    isOnline: true,
    isTyping: false,
    lastMessageTime: "3d ago",
    unreadCount: 0,
  },

  {
    userId: "T001",
    name: "Michael Smith",
    firstName: "Michael",
    lastName: "Smith",
    role: "TASKER",
    category: "Plumber",
    avatar:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    isOnline: true,
    isTyping: true,
    lastMessageTime: "5min ago",
    unreadCount: 2,
  },
  {
    userId: "T002",
    name: "John Doe",
    firstName: "John",
    lastName: "Doe",
    role: "TASKER",
    category: "Electrician",
    avatar:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    isOnline: true,
    isTyping: false,
    lastMessageTime: "2h ago",
    unreadCount: 0,
  },
  {
    userId: "T003",
    name: "Emma Watson",
    firstName: "Emma",
    lastName: "W.",
    role: "TASKER",
    category: "Interior Designer",
    avatar: "",
    isOnline: false,
    isTyping: false,
    lastMessageTime: "1d ago",
    unreadCount: 1,
  },
  {
    userId: "T004",
    name: "Michael R.",
    firstName: "Michael",
    lastName: "R.",
    role: "TASKER",
    category: "Carpenter",
    avatar:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    isOnline: true,
    isTyping: false,
    lastMessageTime: "3d ago",
    unreadCount: 0,
  },
];

export const clients = [
  {
    userId: "C001",
    name: "John Doe",
    firstName: "John",
    lastName: "Doe",
    role: "CLIENT",
    avatar:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    isOnline: true,
    isTyping: true,
    lastMessageTime: "5min ago",
    unreadCount: 2,
  },
];

export const chats = [
  {
    chatId: "123456",
    participants: {
      client: {
        userId: "C001",
        name: "John Doe",
        role: "CLIENT",
      },
      tasker: {
        userId: "T001",
        name: "Michael Smith",
        role: "TASKER",
        skills: ["Plumbing", "Electrical", "Gardening"],
      },
    },
    messages: [
      {
        messageId: "M001",
        senderId: "C001",
        receiverId: "T001",
        timestamp: "2025-02-01T10:00:00Z",
        messageType: "text",
        content:
          "Hi Michael, I need plumbing repair and an electrical checkup at my house. Are you available?",
      },
      {
        messageId: "M002",
        senderId: "T001",
        receiverId: "C001",
        timestamp: "2025-02-01T10:05:00Z",
        messageType: "text",
        content:
          "Hi John! Yes, I can do both plumbing and electrical checkups. What is your preferred date?",
      },
      {
        messageId: "M003",
        senderId: "C001",
        receiverId: "T001",
        timestamp: "2025-02-01T10:07:00Z",
        messageType: "text",
        content: "I would like it done on May 31st. Can you provide an offer?",
      },
      {
        messageId: "M004",
        senderId: "T001",
        receiverId: "C001",
        timestamp: "2025-02-01T10:10:00Z",
        messageType: "offer",
        offer: {
          offerId: "OFFER001",
          taskerId: "T001",
          clientId: "C001",
          task: "Plumbing Repair and Electrical Checkup",
          details:
            "Thanks for reaching out. This is something I can do. I am sending you my offer. If you accept, we can start.",
          date: "2025-05-31",
          price: 150.0,
          status: "pending",
        },
      },
      {
        messageId: "M005",
        senderId: "C001",
        receiverId: "T001",
        timestamp: "2025-02-01T10:15:00Z",
        messageType: "text",
        content: "Thank you! Looking forward to it.",
      },
      {
        messageId: "M006",
        senderId: "C001",
        receiverId: "T001",
        timestamp: "2025-02-01T10:20:00Z",
        messageType: "offerAction",
        offerId: "OFFER001",
        action: "accepted",
      },
      {
        messageId: "M007",
        senderId: "system",
        timestamp: "2025-02-01T10:21:00Z",
        // receiverId: "T001",
        messageType: "order",
        order: {
          orderId: "ORDER001",
          offerId: "OFFER001",
          taskerId: "T001",
          clientId: "C001",
          task: "Plumbing Repair and Electrical Checkup",
          date: "2025-05-31",
          price: 150.0,
          status: "confirmed",
        },
      },
      {
        messageId: "M008",
        senderId: "T001",
        receiverId: "C001",
        timestamp: "2025-02-01T10:25:00Z",
        messageType: "text",
        content: "Your order is confirmed. I will be there on May 31st!",
      },
      {
        messageId: "M009",
        senderId: "C001",
        receiverId: "T001",
        timestamp: "2025-06-01T15:00:00Z",
        messageType: "text",
        content:
          "Thank you for your service! The work was great. I may need some gardening work next week.",
      },
      {
        messageId: "M010",
        senderId: "T001",
        receiverId: "C001",
        timestamp: "2025-06-01T15:10:00Z",
        messageType: "text",
        content:
          "Glad to hear that! Let me know when you're ready, and I can send an offer.",
      },
    ],
  },
  {
    chatId: "234567",
    participants: {
      client: {
        userId: "C002",
        name: "Jane Doe",
        role: "CLIENT",
      },
      tasker: {
        userId: "T002",
        name: "John Doe",
        role: "TASKER",
        skills: ["Electrical", "HVAC", "Plumbing"],
      },
    },
    messages: [
      {
        messageId: "M001",
        senderId: "C002",
        receiverId: "T002",
        timestamp: "2025-02-01T10:00:00Z",
        messageType: "text",
        content:
          "Hi John, I need an electrical system maintenance check. Are you available?",
      },
      {
        messageId: "M002",
        senderId: "T002",
        receiverId: "C002",
        timestamp: "2025-02-01T10:05:00Z",
        messageType: "text",
        content:
          "Hi Jane! Yes, I can do an electrical system maintenance check. What is your preferred date?",
      },
      {
        messageId: "M003",
        senderId: "C002",
        receiverId: "T002",
        timestamp: "2025-02-01T10:07:00Z",
        messageType: "text",
        content: "I would like it done on June 2nd. Can you provide an offer?",
      },
      {
        messageId: "M004",
        senderId: "T002",
        receiverId: "C002",
        timestamp: "2025-02-01T10:10:00Z",
        messageType: "offer",
        offer: {
          offerId: "OFFER002",
          taskerId: "T002",
          clientId: "C002",
          task: "Electrical System Maintenance",
          details:
            "Complete electrical system check and maintenance, including circuit testing and outlet inspection.",
          date: "2025-06-02",
          price: 200.0,
          status: "accepted",
        },
      },
      {
        messageId: "M005",
        senderId: "C002",
        receiverId: "T002",
        timestamp: "2025-02-01T10:15:00Z",
        messageType: "text",
        content: "Thank you! Looking forward to it.",
      },
      {
        messageId: "M006",
        senderId: "C002",
        receiverId: "T002",
        timestamp: "2025-02-01T10:20:00Z",
        messageType: "offerAction",
        offerId: "OFFER002",
        action: "accepted",
      },
      {
        messageId: "M007",
        senderId: "system",
        timestamp: "2025-02-01T10:21:00Z",
        messageType: "order",
        order: {
          orderId: "ORDER002",
          offerId: "OFFER002",
          taskerId: "T002",
          clientId: "C002",
          task: "Electrical System Maintenance",
          date: "2025-06-02",
          price: 200.0,
          status: "confirmed",
        },
      },
      {
        messageId: "M008",
        senderId: "T002",
        receiverId: "C002",
        timestamp: "2025-02-01T10:25:00Z",
        messageType: "text",
        content: "Your order is confirmed. I will be there on June 2nd!",
      },
      {
        messageId: "M009",
        senderId: "C002",
        receiverId: "T002",
        timestamp: "2025-06-03T15:00:00Z",
        messageType: "text",
        content:
          "Thank you for your service! The electrical system is working great now.",
      },
    ],
  },
];

export const plumberImages = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1538474705339-e87de81450e8?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8cGx1bWJpbmd8ZW58MHx8MHx8fDA%3D",
    alt: "Revision Image 1",
  },
  {
    id: 2,
    src: "https://plus.unsplash.com/premium_photo-1663045495725-89f23b57cfc5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8cGx1bWJpbmd8ZW58MHx8MHx8fDA%3D",
    alt: "Revision Image 2",
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1608283833336-5fb6f919e5ea?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fHBsdW1iaW5nfGVufDB8fDB8fHww",
    alt: "Revision Image 1",
  },
];

export const contactUsData = [
  { _id: "1", type: "Service Provider" },
  { _id: "2", type: "Client" },
];

export const jobs = [
  {
    id: 1,
    jobTitle: "Plumbing Repair and Electrical Checkup",
    location: "Colombo 01",
    jobDate: "2025-02-14",
    jobTime: "10:00 PM",
    jobPostedTime: "Just Now",
    category: "Home Services",
    skill: "Plumbing Repair",
    jobImage:
      "https://images.unsplash.com/photo-1538474705339-e87de81450e8?w=500&auto=format&fit=crop&q=60",
  },
  {
    id: 2,
    jobTitle: "Plumbing Repair and Electrical Checkup",
    location: "Colombo 02",
    jobDate: "2025-03-01",
    jobTime: "09:30 AM",
    jobPostedTime: "Just Now",
    category: "Home Services",
    skill: "Plumbing Repair",
    jobImage:
      "https://plus.unsplash.com/premium_photo-1663045495725-89f23b57cfc5?w=500&auto=format&fit=crop&q=60",
  },
  {
    id: 3,
    jobTitle: "Plumbing Repair and Electrical Checkup",
    location: "Colombo 03",
    jobDate: "2025-04-12",
    jobTime: "02:00 PM",
    jobPostedTime: "5 minutes ago",
    category: "Home Services",
    skill: "Plumbing Repair",
    jobImage:
      "https://images.unsplash.com/photo-1608283833336-5fb6f919e5ea?w=500&auto=format&fit=crop&q=60",
  },
  {
    id: 4,
    jobTitle: "Plumbing Repair and Electrical Checkup",
    location: "Colombo 04",
    jobDate: "2025-05-31",
    jobTime: "01:00 PM",
    jobPostedTime: "1 hour ago",
    category: "Home Services",
    skill: "Plumbing Repair",
    jobImage:
      "https://plus.unsplash.com/premium_photo-1663011218145-c1d0c3ba3542?w=500&auto=format&fit=crop&q=60",
  },
  {
    id: 5,
    jobTitle: "Plumbing Repair and Electrical Checkup",
    location: "Colombo 05",
    jobDate: "2025-06-10",
    jobTime: "04:45 PM",
    jobPostedTime: "2 hours ago",
    category: "Home Services",
    skill: "Plumbing Repair",
    jobImage:
      "https://plus.unsplash.com/premium_photo-1683141117531-12fb5bb6855f?w=500&auto=format&fit=crop&q=60",
  },
];

export const sampleFeedJobs = [
  {
    id: 1,
    title: "Plumbing Repair and Electrical Checkup",
    image:
      "https://images.unsplash.com/photo-1538474705339-e87de81450e8?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8cGx1bWJpbmd8ZW58MHx8MHx8fDA%3D",
    location: "Colombo 1",
    jobTasks: ["Home Services", "Plumbing Repair"],
    date: "2024-05-31",
    time: "10:00 PM",
  },
  {
    id: 2,
    title: "Plumbing Repair and Electrical Checkup",
    image:
      "https://images.unsplash.com/photo-1538474705339-e87de81450e8?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8cGx1bWJpbmd8ZW58MHx8MHx8fDA%3D",
    location: "Colombo 1",
    jobTasks: ["Home Services", "Plumbing Repair"],
    date: "2024-05-31",
    time: "10:00 PM",
  },
  {
    id: 3,
    title: "Plumbing Repair and Electrical Checkup",
    image:
      "https://images.unsplash.com/photo-1538474705339-e87de81450e8?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8cGx1bWJpbmd8ZW58MHx8MHx8fDA%3D",
    location: "Colombo 1",
    jobTasks: ["Home Services", "Plumbing Repair"],
    date: "2024-05-31",
    time: "10:00 PM",
  },
];

export const newChatFormat = [
  {
    sender: "67a9c3f5e57bc3b49b29e715",
    offer: "67b1fd23da834389438b3d68",
    content: null,
    attachments: [],
    iv: null,
    messageTye: "OFFER",
    _id: "67b1fd23da834389438b3d6a",
    createdAt: "2025-02-16T14:58:43.671Z",
    updatedAt: "2025-02-16T14:58:43.671Z",
  },
  {
    sender: "67a9c3f5e57bc3b49b29e715",
    content:
      "Hi Michael, I need plumbing repair and an electrical checkup at my house. Are you available?",
    attachments: [
      "https://www.stepbystepinspections.net/wp-content/uploads/2024/12/Winter-Plumbing-Problems-and-Prevention-1.png",
      "https://firebasestorage.googleapis.com/v0/b/coursepivot-a7190.firebasestorage.app/o/order%2F1739243402775Antony%20New%20Bugs.docx?alt=media&token=9456ca69-5c83-4f66-92a0-336b0e2d7556",
    ],
    iv: null,
    messageTye: "TEXT",
    _id: "67b1fd58da834389438b3e55",
    createdAt: "2025-02-16T14:59:36.981Z",
    updatedAt: "2025-02-16T14:59:36.981Z",
  },
  {
    sender: "67a9c3f5e57bc3b49b29e714",
    content:
      "Hi John! Yes, I can do both plumbing and electrical checkups. What is your preferred date?",
    attachments: [],
    iv: null,
    messageTye: "TEXT",
    _id: "67b1fd58da834389438b3e56",
    createdAt: "2025-02-16T14:59:36.981Z",
    updatedAt: "2025-02-16T14:59:36.981Z",
  },
  {
    sender: "67a9c3f5e57bc3b49b29e715",
    content: "I would like it done on May 31st. Can you provide an offer?",
    attachments: [],
    iv: null,
    messageTye: "TEXT",
    _id: "67b1fd58da834389438b3e57",
    createdAt: "2025-02-16T14:59:36.981Z",
    updatedAt: "2025-02-16T14:59:36.981Z",
  },
  {
    sender: "67a9c3f5e57bc3b49b29e714",
    content:
      "Thanks for reaching out. This is something I can do. I am sending you my offer. If you accept, we can start.",
    attachments: [],
    iv: null,
    messageTye: "TEXT",
    _id: "67b1fd58da834389438b3e58",
    createdAt: "2025-02-16T14:59:36.981Z",
    updatedAt: "2025-02-16T14:59:36.981Z",
  },
  {
    sender: "67a9c3f5e57bc3b49b29e714",
    content: null,
    attachments: [],
    iv: null,
    messageTye: "OFFER",
    offer: {
      offerId: "67b1fd23da834389438b3d68",
      task: "Plumbing Repair and Electrical Checkup",
      details:
        "Thanks for reaching out. This is something I can do. I am sending you my offer. If you accept, we can start.",
      date: "2025-02-28T14:59:36.981Z",
      time: "10:00 PM",
      price: 150,
      offerStatus: offerStatus.DECLINED,
    },
    _id: "67b1fd58da834389438b3e59",
    createdAt: "2025-02-16T14:59:36.981Z",
    updatedAt: "2025-02-16T14:59:36.981Z",
  },
  {
    sender: "67a9c3f5e57bc3b49b29e714",
    content: null,
    attachments: [],
    iv: null,
    messageTye: "OFFER",
    offer: {
      offerId: "67b1fd23da834389438b3d68",
      task: "Plumbing Repair and Electrical Checkup",
      details:
        "Thanks for reaching out. This is something I can do. I am sending you my offer. If you accept, we can start.",
      date: "2025-02-28T14:59:36.981Z",
      time: "10:00 PM",
      price: 150,
      offerStatus: offerStatus.PENDING,
    },
    _id: "67b1fd58da834389438b3e59",
    createdAt: "2025-02-16T14:59:36.981Z",
    updatedAt: "2025-02-16T14:59:36.981Z",
  },
];

export const chatUsers = [
  {
    userId: "67a9c3f5e57bc3b49b29e715",
    name: "Michael Smith",
    firstName: "Michael",
    lastName: "Smith",
    role: "TASKER",
    category: "Plumber",
    avatar:
      "https://plus.unsplash.com/premium_photo-1683121004450-ced102f8db0e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGhvbWUlMjBwYWludGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    isOnline: true,
    isTyping: true,
    lastMessageTime: "5min ago",
    unreadCount: 2,
  },
];
